import { ISubscription } from '../../../interface/concretes/subscription.interface';
import { GroupStep } from '../components/group-step.model';
import { Step } from '../components/step.model';

export class Subscription implements ISubscription {
  private _groupSteps: GroupStep[];

  constructor(groupSteps: GroupStep[]) {
    this._groupSteps = groupSteps.map((groupStep) => new GroupStep(groupStep.steps));
  }

  addGroupStep(step: GroupStep): void {
    this._groupSteps.push(step);
  }

  get groupSteps(): GroupStep[] {
    return this._groupSteps;
  }

  getGroupSteps(): GroupStep[] {
    return this._groupSteps;
  }

  set groupSteps(value: GroupStep[]) {
    this._groupSteps = value;
  }

  removeGroupStep(groupStep: GroupStep): void {
    this._groupSteps = this._groupSteps.filter((s) => s !== groupStep);
  }

  updateGroupStep(groupStep: GroupStep, index: number): void {
    this._groupSteps[index] = groupStep;
  }

  getGroupStep(index: number): GroupStep {
    return this._groupSteps[index]!;
  }

  getCurrentStep(indexG: number, index: number): Step {
    return this._groupSteps[indexG]!.steps[index]!;
  }

  findStepIndexesByUrl(targetUrl: string): { groupIndex: number; stepIndex: number } | null {
    const groupIndex = this._groupSteps
      .map((groupStep, gIndex) => {
        // Recherche de l'index de la Step correspondant à l'URL dans chaque GroupStep
        const stepIndex = groupStep.steps.findIndex((step) => step.url === targetUrl);
        return stepIndex !== -1 ? { groupIndex: gIndex, stepIndex } : null;
      })
      .find((result) => result !== null);

    this.activateStepByUrl(targetUrl);
    return groupIndex || null;
  }

  activateStepByUrl(url: string, groupIndex?: number, skipIfAlreadyActive = false): Step | null {
    let activatedStep: Step | null = null;
    let activatedGroupIndex: number | null = null;

    const processStep = (step: Step, gIndex: number, sIndex: number) => {
      if (step.url === url.split('/')[1]) {
        if (skipIfAlreadyActive && step.isActive) {
          activatedStep = step;
          activatedGroupIndex = gIndex;
          return;
        }

        // Désactiver toutes les steps des groupes précédents
        for (let i = 0; i < gIndex; i++) {
          this._groupSteps[i]?.steps.forEach((s) => (s.isActive = false));
        }

        // Désactiver toutes les autres steps du groupe courant
        this._groupSteps[gIndex]?.steps.forEach((s) => (s.isActive = false));

        // Activer la step ciblée
        step.isActive = true;
        activatedStep = step;
        activatedGroupIndex = gIndex;
      }
    };

    if (groupIndex != null) {
      const groupStep = this._groupSteps[groupIndex];
      if (!groupStep) return null;
      groupStep.steps.forEach((step, sIndex) => processStep(step, groupIndex, sIndex));
    } else {
      this._groupSteps.forEach((groupStep, gIndex) => {
        groupStep.steps.forEach((step, sIndex) => processStep(step, gIndex, sIndex));
      });
    }

    return activatedStep;
  }

  setCurrentStep(indexG: number, index: number, step: Step) {
    this._groupSteps[indexG]!.steps[index] = step;
  }

  getLastStepInGroupStep(index: number): number | undefined {
    const steps = this._groupSteps[index]?.steps;
    return steps && steps.length > 0 ? steps[steps.length - 1]?.layoutInfo.stepShow : undefined;
  }

  getGroupStepsCount(): number {
    return this._groupSteps.length;
  }

  getStepsCountInGroup(index: number): number {
    return this._groupSteps[index]?.steps.length ?? -1;
  }

  clearSteps(): void {
    this._groupSteps = [];
  }
}
